export const CMAP_RELEASE_STATUS_DRAFT = 0
export const CMAP_RELEASE_STATUS_IN_REVIEW = 1
export const CMAP_RELEASE_STATUS_REJECTED = 2
export const CMAP_RELEASE_STATUS_UPLOADING = 3
export const CMAP_RELEASE_STATUS_DSP_REJECTED = 4
export const CMAP_RELEASE_STATUS_DSP_IN_REVIEW = 5
export const CMAP_RELEASE_STATUS_PUBLISHED = 6
export const CMAP_RELEASE_STATUS_EDITING = 7
export const CMAP_RELEASE_STATUS_REAPPLY = 8
export const CMAP_RELEASE_STATUS_DSP_REAPPLY = 9
export const CMAP_RELEASE_STATUS_APPEND_DSP = 10
export const CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN = 11
export const CMAP_RELEASE_STATUS_TAKE_DOWN = 12
export const CMAP_RELEASE_STATUS_RELEASE_REJECTED = 13
export const CMAP_RELEASE_STATUS_UPLOADING_TAKE_DOWN = 14
export const CMAP_RELEASE_STATUS_PREPARE_REJECTED = 15
export const CMAP_RELEASE_STATUS_PREPARE_RELEASE_REJECTED = 16
export const CMAP_RELEASE_STATUS_EDIT_UPLOADING = 17

export const CMAP_RELEASE_STATUS_NAMES = {
  0: '下書き',
  1: '審査中(narasu)',
  2: '差し戻し(narasu)',
  3: '納品中',
  4: '差し戻し(DSP)',
  5: '配信待ち',
  6: '配信中',
  7: '更新中',
  8: '再申請(narasu)',
  9: '再申請(DSP)',
  10: '追加ストア申請',
  11: '要配信停止',
  12: '配信停止',
  13: '却下',
  14: '納品中(テイクダウン)',
  15: '要差し戻し',
  16: '要却下',
  17: '更新納品中',
}

export const REVENUE_SHARE_STATUS = {
  1: '承認待ち',
  2: '承認待ち',
  3: '確定',

}
export const CMAP_COPYRIGHT_STATUS_REMAND = 4
export const CMAP_COPYRIGHT_STATUS_REJECTED = 9
export const CMAP_COPYRIGHT_STATUS_PROCESSING = 3
export const CMAP_COPYRIGHT_STATUS_IN_REVIEW = 2
export const CMAP_COPYRIGHT_STATUS_IN_PROGRESS = 1
export const CMAP_COPYRIGHT_STATUS_IN_PENDING = 7
export const CMAP_COPYRIGHT_SPLIT_STATUS_PENDING_BEFORE_INVITATION = 1
export const CMAP_COPYRIGHT_SPLIT_STATUS_PENDING_AFTER_INVITATION = 2
export const CMAP_COPYRIGHT_SPLIT_STATUS_COMPLETED = 3
export const CMAP_COPYRIGHT_SPLIT_STATUS_CANCELLED = 4
export const CMAP_COPYRIGHT_JASCRAC_REVIEW_IN_PROGRESS = 8
export const CMAP_COPYRIGHT_CREATE_JWR_FILE = 10
export const CMAP_COPYRIGHT_STATUS_NAMES = {
  1: '作成中',
  2: '審査中',
  3: '管理中',
  4: '差し戻し',
  7: '承認待ち',
  8: 'JASRAC審査中',
  9: '却下',
  10: 'JWRファイル作成',
}

export const REVENUE_SHARE_COMPLETE_STATUS = {
  0: '承認待ち',
  1: '完了',
}
